import gql from "graphql-tag";
import { Company, Location } from "../baseTypes";
export default gql`
  query ListAllLocationsWithCompany {
    listLocations(limit: 500) {
      items {
        company {
          id
          name
        }
        id
        locationId
        healthDeparmentNumber
        name
      }
    }
  }
`;
export interface ListAllLocationsWithCompanyQuery {
  listLocations: {
    items: Array<Location & { company: Company }> | null;
  };
}
